export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/mashq.96385005.svg","height":17,"width":88,"blurWidth":0,"blurHeight":0};